import { render, staticRenderFns } from "./PatentMiniPanel.vue?vue&type=template&id=106a6545&"
import script from "./PatentMiniPanel.vue?vue&type=script&lang=js&"
export * from "./PatentMiniPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports